<div class="tab-section">
  <div class="eq-tipo-nav">
    <div class="eq-tipo-pills">
      <button
        type="button"
        class="eq-tipo-pill"
        [class.active]="activeTab === 'all'"
        (click)="onTabChange('all')"
      >
        <i class="ri-apps-line"></i>
        Todos
        <span class="pill-badge">{{ equipamentos.length }}</span>
      </button>
      <button
        type="button"
        *ngFor="let tipo of tiposUnicos; trackBy: trackByTipoId"
        class="eq-tipo-pill"
        [class.active]="activeTab === tipo.tipoEquipamentoId"
        [disabled]="isTabPillDisabled(tipo.tipoEquipamentoId)"
        (click)="onTabChange(tipo.tipoEquipamentoId)"
      >
        <i [class]="getIconForTipo(tipo.tipoEquipamentoId)"></i>
        {{ tipo.tipoEquipamentoDescricao.trim() }}
        <span class="pill-badge" [class]="getCobBadgeClass(tipo.tipoEquipamentoId)">
          {{ getCoberturaDoTipo(tipo.tipoEquipamentoId).alocado }}/{{ tipo.quantidade }}
        </span>
      </button>
    </div>
  </div>

  <div class="eq-sem-tipos" *ngIf="!loading && tiposUnicos.length === 0">
    <i class="ri-alert-line"></i>
    <div>
      <p class="eq-sem-tipos-title">Sem tipos de equipamento configurados</p>
      <p class="eq-sem-tipos-sub">Configure primeiro os tipos e as quantidades necessárias ao editar este posto.</p>
    </div>
  </div>

  <div class="eq-cobertura-global" *ngIf="!loading && tiposUnicos.length > 0 && activeTab === 'all'">
    <div class="eq-cob-progress-wrap">
      <div class="eq-cob-summary-line">
        <span>Cobertura global</span>
        <strong>{{ coberturaGlobal.percent }}%</strong>
      </div>
      <div class="eq-cob-bar-wrap">
        <div class="eq-cob-bar" [style.width.%]="coberturaGlobal.percent" [style.background]="getCobBarColor(coberturaGlobal.percent)"></div>
      </div>
      <span class="eq-cob-text">{{ coberturaGlobal.alocado }} de {{ coberturaGlobal.necessario }} equipamentos cobertos</span>
    </div>
    <span class="eq-cob-pill" [class.completa]="coberturaGlobal.percent >= 100" [class.parcial]="coberturaGlobal.percent > 0 && coberturaGlobal.percent < 100" [class.sem-cob]="coberturaGlobal.percent === 0">
      {{ coberturaGlobal.percent >= 100 ? "Cobertura completa" : coberturaGlobal.percent > 0 ? "Cobertura parcial" : "Sem cobertura" }}
    </span>
  </div>

  <ng-container *ngIf="!loading && activeTab !== 'all' && activeTipo as tipoAtivo">
    <div class="eq-tipo-summary">
      <div class="eq-ts-icon"><i [class]="getIconForTipo(tipoAtivo.tipoEquipamentoId)"></i></div>
      <div class="eq-ts-body">
        <div class="eq-ts-title-row">
          <span class="eq-ts-nome">{{ tipoAtivo.tipoEquipamentoDescricao }}</span>
          <strong>{{ getCoberturaPercent(tipoAtivo) }}%</strong>
        </div>
        <div class="eq-ts-bar-row">
          <div class="eq-cob-bar-wrap" style="flex: 1">
            <div class="eq-cob-bar" [style.width.%]="getCoberturaPercent(tipoAtivo)" [style.background]="getCobBarColor(getCoberturaPercent(tipoAtivo))"></div>
          </div>
          <span class="eq-cob-text">{{ coberturaPorTipoMap.get(tipoAtivo.tipoEquipamentoId) ?? 0 }} de {{ tipoAtivo.quantidade }} alocados</span>
        </div>
      </div>
      <span class="eq-cob-pill" [class.completa]="getCoberturaPercent(tipoAtivo) >= 100" [class.parcial]="getCoberturaPercent(tipoAtivo) > 0 && getCoberturaPercent(tipoAtivo) < 100" [class.sem-cob]="getCoberturaPercent(tipoAtivo) === 0">
        {{ getCoverageLabel(tipoAtivo.tipoEquipamentoId) }}
      </span>
    </div>
  </ng-container>

  <div class="eq-list-heading" *ngIf="!loading && tiposUnicos.length > 0">
    <div>
      <span>INVENTÁRIO DO POSTO</span>
      <h3>Equipamentos associados</h3>
      <p>Consulte os ativos adicionados, acompanhe a cobertura e use os filtros para localizar um equipamento.</p>
    </div>
    <span class="eq-list-total"><strong>{{ equipamentos.length }}</strong> associado{{ equipamentos.length !== 1 ? "s" : "" }}</span>
  </div>
  <div class="eq-toolbar" *ngIf="!loading && tiposUnicos.length > 0">
    <div class="eq-toolbar-left">
      <div class="eq-search-wrap eq-main-search">
        <i class="ri-search-line"></i>
        <input class="sp-input" [(ngModel)]="searchQuery" (ngModelChange)="page = 1" placeholder="Pesquisar equipamento..." />
        <button type="button" *ngIf="searchQuery" class="eq-clear-search" aria-label="Limpar pesquisa" (click)="removeSearchFilter()"><i class="ri-close-line"></i></button>
      </div>
      <span class="eq-results-count">{{ totalFiltrado }} resultado{{ totalFiltrado !== 1 ? "s" : "" }}</span>
    </div>
    <div class="eq-toolbar-actions">
      <button type="button" class="btn-secondary btn-sm eq-filter-button" (click)="openFiltrosDrawer()">
        <i class="ri-filter-3-line"></i> Filtros
        <span class="eq-filter-count" *ngIf="activeFiltersCount">{{ activeFiltersCount }}</span>
      </button>
      <button type="button" class="btn-primary btn-sm" (click)="openDrawerForTab()">
        <i class="ri-add-line"></i> Adicionar equipamento
      </button>
    </div>
  </div>

  <div class="eq-active-filters" *ngIf="!loading && hasActiveFilters">
    <span *ngIf="searchQuery"><i class="ri-search-line"></i> “{{ searchQuery }}”</span>
    <span *ngIf="filtroTipoId !== null"><i class="ri-stack-line"></i> {{ getTipoNome(filtroTipoId) }}</span>
    <span *ngIf="filtroCobertura !== 'all'"><i class="ri-pie-chart-line"></i> {{ filtroCobertura === 'covered' ? 'Cobertas' : filtroCobertura === 'partial' ? 'Parciais' : 'Sem cobertura' }}</span>
    <button type="button" (click)="limparFiltros(false)">Limpar filtros</button>
  </div>

  <div class="eq-list-legend" *ngIf="!loading && totalFiltrado > 0">
    <span class="legend-title"><i class="ri-information-line"></i> Legenda da cobertura</span>
    <span><i class="dot covered"></i> Coberta: quantidade necessária atingida</span>
    <span><i class="dot partial"></i> Parcial: ainda faltam unidades</span>
    <span><i class="dot missing"></i> Em falta: nenhuma unidade associada</span>
  </div>

  <div class="skeleton-list" *ngIf="loading">
    <p-skeleton *ngFor="let skeleton of skeletons" height="62px" borderRadius="9px"></p-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <div class="necc-table" *ngIf="necessidadesPaginadas.length > 0; else emptyNecessidades">
      <div class="necc-header">
        <span>#</span>
        <span>Equipamento</span>
        <span>Tipo</span>
        <span>Quantidade</span>
        <span>Cobertura</span>
        <span></span>
      </div>
      <div class="necc-row" *ngFor="let item of necessidadesPaginadas; let i = index; trackBy: trackById">
        <div class="necc-num">{{ (page - 1) * pageSize + i + 1 }}</div>
        <div class="necc-eq-info">
          <span class="necc-nome">{{ item.nomeEquipamento || "EQ-" + item.equipamentoId }}</span>
          <span class="necc-codigo">ID {{ item.equipamentoId }} <ng-container *ngIf="item.codigoInterno">· {{ item.codigoInterno }}</ng-container></span>
        </div>
        <div><span class="necc-tipo-pill"><i [class]="getIconForTipo(item.tipoEquipamentoId)"></i>{{ item.tipoEquipamento }}</span></div>
        <div><span class="necc-qtd-badge">{{ item.quantidade }}</span></div>
        <div>
          <span class="necc-coverage" [class]="getCoverageState(item.tipoEquipamentoId)">
            <i [class]="getCoverageState(item.tipoEquipamentoId) === 'covered' ? 'ri-checkbox-circle-line' : getCoverageState(item.tipoEquipamentoId) === 'partial' ? 'ri-time-line' : 'ri-error-warning-line'"></i>
            {{ getCoverageLabel(item.tipoEquipamentoId) }}
          </span>
        </div>
        <div class="necc-actions">
          <button type="button" class="necc-btn-remove" pTooltip="Remover necessidade" tooltipPosition="left" (click)="removerEquipamento(item)"><i class="ri-delete-bin-line"></i></button>
        </div>
      </div>
    </div>

    <ng-template #emptyNecessidades>
      <div class="eq-empty-state">
        <div class="eq-empty-visual">
          <span></span><i class="ri-inbox-archive-line"></i><b class="dot-one"></b><b class="dot-two"></b>
        </div>
        <p>{{ hasActiveFilters ? "Nenhum resultado encontrado" : "Nenhum equipamento associado" }}</p>
        <small>{{ hasActiveFilters ? "Ajuste ou limpe os filtros para ver outros equipamentos." : "Utilize “Adicionar equipamento” no topo para selecionar os primeiros ativos deste posto." }}</small>
      </div>
    </ng-template>

    <div class="eq-pag-wrap" *ngIf="totalFiltrado > 0">
      <app-paginator-control
        [first]="(page - 1) * pageSize"
        [rows]="pageSize"
        [totalRecords]="totalFiltrado"
        [rowsPerPageOptions]="[5, 10, 20]"
        [alwaysShow]="false"
        [showCurrentPageReport]="true"
        (pageChange)="onPageChange($event)"
      />
    </div>
  </ng-container>
</div>

<p-drawer
  [(visible)]="showDrawer"
  position="right"
  [modal]="true"
  [style]="{ width: 'min(720px, 96vw)' }"
  styleClass="eq-drawer eq-need-drawer"
  appendTo="body"
  (onHide)="resetDrawerState()"
>
  <ng-template pTemplate="header">
    <div class="eq-drawer-header">
      <span class="eq-drawer-header-icon"><i class="ri-tools-fill"></i></span>
      <div>
        <small>GESTÃO DE NECESSIDADES</small>
        <h2>Adicionar equipamento</h2>
        <p>{{ posto?.nome || "Posto selecionado" }}</p>
      </div>
      <span class="eq-selection-badge" *ngIf="drawerSeleccionados.length"><i class="ri-checkbox-multiple-line"></i>{{ drawerSeleccionados.length }} selecionado{{ drawerSeleccionados.length !== 1 ? "s" : "" }}</span>
    </div>
  </ng-template>

  <div class="eq-need-content">
    <div class="eq-drawer-guide" aria-label="Etapas para adicionar equipamento">
      <div class="active" [class.done]="drawerTipoSelecionado !== null">
        <span>1</span>
        <div><strong>Escolher tipo</strong><small>Categoria necessária</small></div>
      </div>
      <i class="ri-arrow-right-line"></i>
      <div [class.active]="drawerTipoSelecionado !== null" [class.done]="drawerSeleccionados.length > 0">
        <span>2</span>
        <div><strong>Selecionar ativos</strong><small>Equipamentos disponíveis</small></div>
      </div>
      <i class="ri-arrow-right-line"></i>
      <div [class.active]="drawerSeleccionados.length > 0">
        <span>3</span>
        <div><strong>Guardar</strong><small>Associar ao posto</small></div>
      </div>
    </div>

    <section class="eq-drawer-card eq-type-card">
      <div class="eq-section-heading">
        <span class="eq-section-icon"><i class="ri-stack-line"></i></span>
        <div><strong>Tipo de equipamento</strong><small>Escolha a categoria necessária para este posto.</small></div>
        <button 
          type="button" 
          class="btn-secondary btn-xs" 
          *ngIf="drawerTipoSelecionado !== null" 
          (click)="selectDrawerTipo(null)"
          title="Ver todos os tipos"
        >
          <i class="ri-close-line"></i> Limpar
        </button>
      </div>

      <div class="eq-type-options" role="radiogroup" aria-label="Tipo de equipamento">
        <button
          type="button"
          class="eq-type-option"
          role="radio"
          *ngFor="let tipo of tiposUnicos; trackBy: trackByTipoId"
          [class.selected]="drawerTipoSelecionado?.tipoEquipamentoId === tipo.tipoEquipamentoId"
          [class.disabled]="isDrawerOptionDisabled(tipo.tipoEquipamentoId)"
          [disabled]="isDrawerOptionDisabled(tipo.tipoEquipamentoId)"
          [attr.aria-checked]="drawerTipoSelecionado?.tipoEquipamentoId === tipo.tipoEquipamentoId"
          (click)="selectDrawerTipo(tipo)"
        >
          <span class="eq-type-option-icon">
            <i [class]="getIconForTipo(tipo.tipoEquipamentoId)"></i>
          </span>
          <span class="eq-type-option-copy">
            <strong>{{ tipo.tipoEquipamentoDescricao.trim() }}</strong>
            <small>{{ getCoberturaDoTipo(tipo.tipoEquipamentoId).alocado }} de {{ tipo.quantidade }} cobertos</small>
          </span>
          <span class="eq-type-option-check">
            <i [class]="drawerTipoSelecionado?.tipoEquipamentoId === tipo.tipoEquipamentoId ? 'ri-check-line' : 'ri-arrow-right-s-line'"></i>
          </span>
          <span class="eq-type-option-need">
            <small>Necessários</small>
            <strong>{{ tipo.quantidade }}</strong>
          </span>
        </button>
      </div>

      <div class="eq-drawer-coverage" *ngIf="drawerTipoSelecionado as selectedType">
        <div class="eq-coverage-metrics">
          <div><small>Atualmente</small><strong>{{ getCoberturaDoTipo(selectedType.tipoEquipamentoId).alocado }}</strong></div>
          <i class="ri-add-line"></i>
          <div class="is-selection"><small>A selecionar</small><strong>{{ totalSeleccionadoQtd }}</strong></div>
          <i class="ri-arrow-right-line"></i>
          <div><small>Necessários</small><strong>{{ selectedType.quantidade }}</strong></div>
        </div>
        <div class="eq-cob-bar-wrap"><div class="eq-cob-bar" [style.width.%]="selectedType.quantidade ? (drawerCoverageAfterSelection / selectedType.quantidade) * 100 : 0" [style.background]="getCobBarColor(selectedType.quantidade ? (drawerCoverageAfterSelection / selectedType.quantidade) * 100 : 0)"></div></div>
        <p class="eq-coverage-help"><i class="ri-information-line"></i>{{ drawerSelectionHelp }}</p>
      </div>
    </section>

    <section class="eq-drawer-card eq-available-section" *ngIf="drawerTipoSelecionado">
      <div class="eq-section-heading eq-section-heading-row">
        <div class="eq-heading-group"><span class="eq-section-icon"><i class="ri-checkbox-multiple-line"></i></span><div><strong>Equipamentos disponíveis</strong><small>Selecione os ativos em bom estado que pretende associar ao posto.</small></div></div>
        <span class="eq-available-count" *ngIf="!drawerLoading">{{ drawerEquipamentosFiltrados.length }} disponível{{ drawerEquipamentosFiltrados.length !== 1 ? "eis" : "" }}</span>
      </div>

      <div class="eq-search-wrap eq-drawer-search">
        <i class="ri-search-line"></i>
        <input class="sp-input" [(ngModel)]="drawerSearch" (ngModelChange)="onDrawerSearchChange()" placeholder="Pesquisar código, marca, modelo, matrícula ou série..." />
        <button type="button" *ngIf="drawerSearch" class="eq-clear-search" aria-label="Limpar pesquisa" (click)="drawerSearch = ''; onDrawerSearchChange()"><i class="ri-close-line"></i></button>
      </div>

      <div class="eq-selection-legend">
        <span><b class="add"><i class="ri-add-line"></i></b> Clique no cartão ou no sinal + para selecionar</span>
        <span><b class="selected"><i class="ri-check-line"></i></b> O visto azul indica um ativo selecionado</span>
      </div>

      <div class="eq-drawer-skeleton" *ngIf="drawerLoading">
        <p-skeleton height="92px" borderRadius="11px" *ngFor="let skeleton of [1, 2, 3]"></p-skeleton>
      </div>

      <ng-container *ngIf="!drawerLoading">
        <div class="eq-available-list" *ngIf="drawerEquipamentosPaginados.length; else noAvailableEquipment">
          <article
            class="eq-available-card"
            *ngFor="let equipamento of drawerEquipamentosPaginados; trackBy: trackById"
            [class.selected]="isEquipamentoSeleccionado(equipamento)"
            [class.disabled]="limiteAtingido && !isEquipamentoSeleccionado(equipamento)"
          >
            <div
              class="eq-available-card-main"
              role="button"
              tabindex="0"
              [attr.aria-label]="(isEquipamentoSeleccionado(equipamento) ? 'Remover ' : 'Selecionar ') + getEquipmentTitle(equipamento)"
              (click)="toggleEquipamento(equipamento)"
              (keydown.enter)="toggleEquipamento(equipamento)"
            >
              <span class="eq-equipment-photo">
                <app-equipment-photo
                  [src]="equipamento.fotoUrl"
                  [alt]="'Fotografia de ' + getEquipmentTitle(equipamento)"
                  [fallbackIcon]="getIconForTipo(drawerTipoSelecionado.tipoEquipamentoId)"
                />
              </span>

              <div class="eq-equipment-body">
                <div class="eq-equipment-topline">
                  <span>{{ equipamento.codigoInterno || "EQ-" + equipamento.id }}</span>
                  <span class="eq-state-badge" [class.is-inactive]="isEquipmentInactive(equipamento)">{{ getEquipmentStateLabel(equipamento) }}</span>
                </div>
                <strong class="eq-equipment-title">{{ getEquipmentTitle(equipamento) }}</strong>
                <div class="eq-equipment-details">
                  <span *ngFor="let detail of getEquipmentDetails(equipamento)" [attr.title]="detail.label + ': ' + detail.value"><i [class]="detail.icon"></i>{{ detail.value }}</span>
                </div>
              </div>

              <div class="eq-equipment-action">
                <button
                  type="button"
                  class="eq-details-trigger"
                  [class.open]="isEquipmentDetailOpen(equipamento.id)"
                  [attr.aria-expanded]="isEquipmentDetailOpen(equipamento.id)"
                  [attr.aria-controls]="'eqDetails' + equipamento.id"
                  (click)="$event.stopPropagation(); toggleEquipmentDetails(equipamento.id)"
                >
                  <i [class]="isEquipmentDetailOpen(equipamento.id) ? 'ri-arrow-up-s-line' : 'ri-eye-line'"></i>
                  <span>{{ isEquipmentDetailOpen(equipamento.id) ? "Ocultar" : "Detalhes" }}</span>
                </button>
                <div class="eq-quantity-control" *ngIf="isEquipamentoSeleccionado(equipamento) && getMaxParaItem(equipamento.id) > 1" (click)="$event.stopPropagation()">
                  <label [for]="'eqQty' + equipamento.id">Qtd.</label>
                  <input [id]="'eqQty' + equipamento.id" type="number" class="sp-input" [ngModel]="getSeleccionadoQtd(equipamento.id)" (ngModelChange)="updateQuantidadeSeleccionado(equipamento.id, $event)" [min]="1" [max]="getMaxParaItem(equipamento.id)" />
                </div>
                <span class="eq-select-check" [class.checked]="isEquipamentoSeleccionado(equipamento)"><i [class]="isEquipamentoSeleccionado(equipamento) ? 'ri-check-line' : 'ri-add-line'"></i></span>
              </div>
            </div>

            <section
              class="eq-equipment-more"
              *ngIf="isEquipmentDetailOpen(equipamento.id)"
              [id]="'eqDetails' + equipamento.id"
              (click)="$event.stopPropagation()"
            >
              <div class="eq-equipment-more-summary">
                <div *ngIf="equipamento.dataAquisicao">
                  <small>Data de aquisição</small>
                  <strong>{{ formatDate(equipamento.dataAquisicao) }}</strong>
                </div>
                <div *ngIf="equipamento.valorAquisicao !== null && equipamento.valorAquisicao !== undefined">
                  <small>Valor de aquisição</small>
                  <strong>{{ formatCurrency(equipamento.valorAquisicao) }}</strong>
                </div>
                <div>
                  <small>Tipo</small>
                  <strong>{{ equipamento.tipoEquipamento?.designacao || drawerTipoSelecionado.tipoEquipamentoDescricao }}</strong>
                </div>
                <div>
                  <small>Disponibilidade</small>
                  <strong>{{ equipamento.idPosto ? "Associado a um posto" : "Disponível" }}</strong>
                </div>
              </div>

              <div class="eq-equipment-observation" *ngIf="equipamento.observacoes">
                <small>Observações</small>
                <p>{{ equipamento.observacoes }}</p>
              </div>

              <div class="eq-equipment-properties" *ngIf="equipamento.propriedades?.length">
                <div class="eq-more-heading"><i class="ri-list-check-3"></i><strong>Informações técnicas</strong><span>{{ equipamento.propriedades?.length }}</span></div>
                <dl>
                  <ng-container *ngFor="let property of equipamento.propriedades">
                    <div *ngIf="property.valor">
                      <dt>{{ getEquipmentPropertyLabel(property.nome) }}</dt>
                      <dd>{{ formatEquipmentPropertyValue(property) }}</dd>
                    </div>
                  </ng-container>
                </dl>
              </div>

              <div class="eq-equipment-documents" *ngIf="equipamento.documentos?.length">
                <div class="eq-more-heading"><i class="ri-attachment-2"></i><strong>Documentos</strong><span>{{ equipamento.documentos?.length }}</span></div>
                <a
                  *ngFor="let documento of equipamento.documentos"
                  [href]="documento.urlFicheiro"
                  target="_blank"
                  rel="noopener noreferrer"
                  [class.disabled]="!documento.urlFicheiro"
                  (click)="!documento.urlFicheiro && $event.preventDefault()"
                ><i class="ri-file-text-line"></i>{{ documento.designacao || documento.nomeArquivo || "Documento" }}<i class="ri-external-link-line"></i></a>
              </div>

              <a class="eq-full-details-link" [routerLink]="['/admin/equipamentos', equipamento.id]" target="_blank" rel="noopener noreferrer">
                <i class="ri-external-link-line"></i>Abrir ficha completa
              </a>
            </section>
          </article>
        </div>

        <ng-template #noAvailableEquipment>
          <div class="eq-drawer-empty">
            <span><i class="ri-search-eye-line"></i></span>
            <strong>{{ drawerSearch ? "Nenhum equipamento encontrado" : "Nenhum equipamento disponível em bom estado" }}</strong>
            <small>{{ drawerSearch ? "Experimente pesquisar por outro termo." : "Não existem ativos livres e em bom estado para este tipo de equipamento." }}</small>
          </div>
        </ng-template>

        <div class="eq-drawer-pagination" *ngIf="drawerEquipamentosFiltrados.length > 0">
          <app-paginator-control
            [first]="(drawerPage - 1) * drawerPageSize"
            [rows]="drawerPageSize"
            [totalRecords]="drawerEquipamentosFiltrados.length"
            [rowsPerPageOptions]="[5, 10, 20]"
            [alwaysShow]="false"
            [showCurrentPageReport]="true"
            (pageChange)="onDrawerPageChange($event)"
          />
        </div>
      </ng-container>
    </section>

    <div class="eq-drawer-intro" *ngIf="!drawerTipoSelecionado">
      <span class="eq-intro-visual"><i class="ri-list-check-3"></i></span>
      <strong>Comece por escolher um tipo</strong>
      <small>Depois serão apresentados apenas os equipamentos em bom estado e ativos dessa categoria.</small>
    </div>

    <section class="eq-selection-summary" *ngIf="drawerSeleccionados.length">
      <div class="eq-selection-summary-head">
        <div><i class="ri-checkbox-multiple-line"></i><strong>Seleção atual</strong><span>{{ totalSeleccionadoQtd }} unidade{{ totalSeleccionadoQtd !== 1 ? "s" : "" }}</span></div>
        <button type="button" (click)="drawerSeleccionados = []; drawerSeleccionadosMap.clear()">Limpar seleção</button>
      </div>
      <div class="eq-selection-chips">
        <span *ngFor="let item of drawerSeleccionados; trackBy: trackByEqId">
          {{ getEquipmentTitle(item.equipamento) }} · {{ item.quantidade }}
          <button type="button" aria-label="Remover da seleção" title="Remover da seleção" (click)="removerSeleccionado(item.equipamentoId)"><i class="ri-close-line"></i></button>
        </span>
      </div>
    </section>
  </div>

  <ng-template pTemplate="footer">
    <div class="eq-drawer-footer">
      <span class="eq-footer-status" *ngIf="drawerTipoSelecionado"><i class="ri-information-line"></i>{{ totalSeleccionadoQtd ? totalSeleccionadoQtd + ' unidade(s) pronta(s) para associar' : 'Selecione pelo menos um equipamento' }}</span>
      <div>
        <button type="button" class="btn-secondary" (click)="closeDrawer()" [disabled]="drawerSaving">Cancelar</button>
        <button type="button" class="btn-primary" [disabled]="!drawerSeleccionados.length || drawerSaving" (click)="salvarNecessidade()">
          <i [class]="drawerSaving ? 'ri-loader-4-line spin' : 'ri-save-3-line'"></i>
          {{ drawerSaving ? "A guardar..." : "Guardar equipamentos" }}
        </button>
      </div>
    </div>
  </ng-template>
</p-drawer>

<p-drawer
  [(visible)]="showFiltrosDrawer"
  position="right"
  [modal]="true"
  [style]="{ width: 'min(410px, 94vw)' }"
  styleClass="eq-drawer eq-filter-drawer"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="eq-drawer-header compact">
      <span class="eq-drawer-header-icon"><i class="ri-filter-3-line"></i></span>
      <div><small>LISTAGEM</small><h2>Filtrar equipamentos</h2><p>Combine os critérios para encontrar rapidamente.</p></div>
    </div>
  </ng-template>

  <div class="eq-filter-content">
    <section class="eq-filter-section">
      <label for="equipmentFilterSearch">Pesquisar</label>
      <div class="eq-search-wrap"><i class="ri-search-line"></i><input id="equipmentFilterSearch" class="sp-input" [(ngModel)]="searchQueryTemp" placeholder="Nome, código ou tipo..." /></div>
    </section>

    <section class="eq-filter-section">
      <div class="eq-filter-heading"><div><strong>Cobertura</strong><small>Estado atual da necessidade</small></div></div>
      <div class="eq-filter-options">
        <button type="button" *ngFor="let option of coberturaOptions" [class.selected]="filtroCoberturaTemp === option.value" (click)="filtroCoberturaTemp = option.value">
          <span><i [class]="option.icon"></i></span><div><strong>{{ option.label }}</strong><small>{{ option.description }}</small></div><i class="ri-check-line check" *ngIf="filtroCoberturaTemp === option.value"></i>
        </button>
      </div>
    </section>

    <section class="eq-filter-section">
      <div class="eq-filter-heading"><div><strong>Tipo de equipamento</strong><small>Categoria configurada no posto</small></div></div>
      <div class="eq-filter-options">
        <button type="button" [class.selected]="filtroTipoTemp === null" (click)="filtroTipoTemp = null"><span><i class="ri-apps-line"></i></span><div><strong>Todos os tipos</strong><small>Não restringir por categoria</small></div><i class="ri-check-line check" *ngIf="filtroTipoTemp === null"></i></button>
        <button type="button" *ngFor="let tipo of tiposUnicos; trackBy: trackByTipoId" [class.selected]="filtroTipoTemp === tipo.tipoEquipamentoId" (click)="filtroTipoTemp = tipo.tipoEquipamentoId">
          <span><i [class]="getIconForTipo(tipo.tipoEquipamentoId)"></i></span><div><strong>{{ tipo.tipoEquipamentoDescricao.trim() }}</strong><small>{{ getCoberturaDoTipo(tipo.tipoEquipamentoId).alocado }} de {{ tipo.quantidade }} cobertos</small></div><i class="ri-check-line check" *ngIf="filtroTipoTemp === tipo.tipoEquipamentoId"></i>
        </button>
      </div>
    </section>
  </div>

  <ng-template pTemplate="footer">
    <div class="eq-filter-footer">
      <button type="button" class="btn-secondary" (click)="limparFiltros()"><i class="ri-refresh-line"></i> Limpar</button>
      <button type="button" class="btn-primary" (click)="aplicarFiltros()"><i class="ri-check-line"></i> Aplicar filtros</button>
    </div>
  </ng-template>
</p-drawer>